import React, { useState } from "react";
import { caseStudiesProcess } from "./CaseStudyData";
import { Col, Container, Row } from "react-bootstrap";
import MajorClient from "../Home/Components/MajorClient";
import Testimonials from "../Home/Components/Testimonials";
import { PiArrowBendDownRightBold } from "react-icons/pi";
import Image1 from "../../Images/CaseStudies/hotel_app.webp";
import { IoMdStar } from "react-icons/io";
import client from "../../Images/CaseStudies/hotel_app.webp";

const HotelManagerApp = () => {
  const [tabName, setTabName] = useState("Business Needs");

  return (
    <div>
      <div className="case_study_details case_study">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11} className="case_content text-center">
              <h1>
                <span>Hotel Manager App</span>
              </h1>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col lg={12}>
            <div className="industrial">
              <img src={Image1} alt={Image1} className="img-fluid" />
              <div className="industrial_content">
                <p>
                  A central place for hotel staff and managers to manage reservations, track assets (guest rooms, catering, technical facilities), monitor workers’ tasks and time logs, and keep organized records of daily operations with role-based access, work diaries, and integrated time tracking.                </p>
                <div className="d-flex flex-wrap align-items-center justify-content-between ">
                  <div>
                    <h4>Industry</h4>
                    <p>
                      <b>Hotels</b>
                    </p>
                  </div>
                  <div>
                    <h4>Country</h4>
                    <p>
                      <b>Germany</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <hr className="m-0" />
      <div className="case_img_box">
        <Container>
          <div className="case_box position-relative">
            <img src={Image1} alt={Image1} />
          </div>
        </Container>
      </div>

      <hr className="m-0" />

      <Container>
        <Row className="case_content_box">
          <Col lg={12} className="px-3">
            <div className="case_content p-3">
              <h2 className="case_heading">About</h2>
              <p>
                {" "}
                Hotel Manager App is a daily operations solution built for mid-size hotels. Team leaders and workers use it to plan, assign, and track work across all hotel facilities. Team leaders create work diary entries and tasks, assigning them to responsible staff who perform the work and update status in real time.
                The application covers a broad range of operational needs including room and facility management, actions such as housekeeping, maintenance, and customer requests, and a dedicated work diary per object. A centralized dashboard displays task and object status, while role-based access, documents and maps, and multi-language support in English, German, and Spanish ensure the system serves diverse hotel teams effectively. The solution is available as a PWA on both browser and mobile, with push notifications keeping all staff informed and accountable.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className=" my-5">
        <div className="process px-3">
          <h2 className="case_heading">Process</h2>
          <Row className="mt-4 justify-content-center">
            {caseStudiesProcess.map((step, index) => (
              <Col lg={3} md={4} sm={6} key={index} className="mb-3">
                <div className="card">
                  <span>{step.step}</span>
                  {step.icon}
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>

      <Container className=" my-5">
        <Row className="mt-5 client_benefits align-items-center">
          <Col md={6}>
            <h2 className="case_heading">Client Benefits</h2>
            <ul className="mt-4 p-0">
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Single centralized place for objects (rooms and facilities), actions, and tasks
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Role-based access control for security and accountability
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Dashboard with key metrics, charts, and real-time data
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Clear assignments with defined ownership and responsibility
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Work diary and activity tracking per object for audit and compliance
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Push notifications for assignments and status updates
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Flexible cross-platform use on browser and PWA (Android and iOS)
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Multi-language support in English, German, and Spanish
              </li>
              <li className="d-flex align-items-center gap-2">
                <IoMdStar />
                Centralized administration panel for users, roles, and actions
              </li>
            </ul>
          </Col>
          <Col md={6}>
            <img src={client} alt={client} className="img-fluid" />
          </Col>
        </Row>
        <hr className="my-5" />

        <div className="challenges my-5">
          <h2 className="case_heading">Challenges </h2>
          <Row className="mt-4 justify-content-center">
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 1</span>
                <h5> Maintaining Multilingual Support Across Multiple Projects</h5>

                <p className="mb-1">
                  <b>Challenge</b> : The app needed multi-language support and language management directly in it, which made maintenance and reuse across projects difficult. Each new project required repeating translation logic, increasing effort and causing inconsistency.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: We built a separate Python-based translation service and deployed it independently. It centralizes language translation and provides APIs for multiple apps. This separation made translation management easier, reusable across projects, and more consistent.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border-left border_bottom border-right">
              <div className="card position-relative">
                <span> 2</span>
                <h5>Optimizing Dashboard Data Aggregation</h5>

                <p className="mb-1">
                  <b>Challenge</b> :The dashboard had to combine several data sources such as object statistics, task status, object status, worker performance, work diary and action data, and upcoming tasks. Aggregating this data efficiently while keeping the UI responsive was a core requirement.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Data flow was optimized by restructuring queries and cutting redundant requests. The backend aggregates the needed metrics before sending them to the frontend, so dashboards load quickly even with large datasets.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 3</span>
                <h5>Designing a Scalable Data Model for Operational Workflows</h5>

                <p className="mb-1">
                  <b>Challenge</b>: Objects, tasks, actions, workers, team leaders, and work diary entries are tightly related. Designing a data model that kept these relationships clear while staying flexible for future changes required careful planning.
                </p>

                <p className="mb-1">
                  <b>Solution</b>:  Normalized data relationships were defined and workflow logic was structured so that tasks and work diary entries stay clearly linked to objects and users. That structure supports consistency, reporting, and future scalability.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="process_tab_box">
          <Row className="justify-content-center">
            <Col lg={10} className="process_tab_list">
              <ul className="p-0">
                <li
                  onClick={() => setTabName("Business Needs")}
                  className={`${tabName === "Business Needs" ? "active" : ""}`}
                >
                  Business Needs
                </li>
                <li
                  onClick={() => setTabName("Objectives Achieved")}
                  className={`${tabName === "Objectives Achieved" ? "active" : ""
                    }`}
                >
                  Objectives Achieved
                </li>
                <li
                  onClick={() => setTabName("Technologies Used")}
                  className={`${tabName === "Technologies Used" ? "active" : ""
                    }`}
                >
                  Technologies Used
                </li>
              </ul>
            </Col>
            <Col lg={10} className="mt-4">
              {tabName === "Business Needs" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Object Management
                        </h6>
                        <p>
                          Create, view, update, and delete objects including guest rooms, technical facilities, outdoor and indoor areas, sanitary, catering, and equipment. Staff can attach maps and documents, manage the work diary and task list per object, and search, sort, and filter by type, status, usage, and location.
                        </p>
                      </li>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Task and Assignment System
                        </h6>
                        <p>
                          Plan, assign, and track tasks, simple or action based, with status, responsible users, and history. Assign workers to objects and define user to user responsibles. The system supports recurring tasks and multiple assignees for flexible operational coverage.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Dashboard and Reporting
                        </h6>
                        <p>
                          A single unified view of task status, object status, worker performance, object types, upcoming tasks, and the worker task timeline, complete with filters and refresh controls for real-time insight.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Administration
                        </h6>
                        <p>
                          Manage assignments, users, roles with module-wise permissions, action setup, and push notifications from a centralized administration panel.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Document Management
                        </h6>
                        <p>
                          Secure cloud storage and access control for documents and images per object, ensuring the right staff have access to the right materials at all times.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Cross-Platform Use
                        </h6>
                        <p>
                          Full functionality available in the browser or as an installed PWA on Android and iOS, supporting both office-based management and floor-level operations.
                        </p>
                      </li>

                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Objectives Achieved" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0">
                          Clear structure for objects, actions, and tasks with consistent links and full traceability
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Role-based access enforced at module level
                        </p>
                      </li>

                      <li>
                        <p className="p-0">
                          Responsive dashboard adapting to user preferences and filters with optional live refresh
                        </p>
                      </li>

                      <li>
                        <p className="p-0">
                          Assignments (object-to-worker and user-to-user) with clear ownership and planning visibility
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Work diary tied to objects and actions for audit and compliance
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Configurable action forms and multi-language labels across English, German, and Spanish
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Push notifications aligned with triggers and responsibilities
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Secure cloud-based document and image storage
                        </p>
                      </li>
                      <li>
                        <p className="p-0">
                          Single app deployment for browser and PWA on Android and iOS
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Technologies Used" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0 mb-2 mt-0">Angular 18, TypeScript </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">Angular Material, Bootstrap, ng-bootstrap </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">RxJS, ngx-translate</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">ApexCharts, FullCalendar</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">Angular PWA</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">.NET Core</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">SQL Server</p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <MajorClient />
      <Testimonials />
      {/* <ContactForm /> */}
    </div>
  );
};

export default HotelManagerApp;
